import { createActions, createReducer } from 'reduxsauce'

import DetalhesMetasEducacaoLiquidacaoService from '../../servicos/DetalhesMetasEducacaoLiquidacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesMetasEducacaoLiquidacaoInicio: [],
    buscaDetalhesMetasEducacaoLiquidacaoSucesso: ['detalhesMetasEducacaoLiquidacao'],
    buscaDetalhesMetasEducacaoLiquidacaoErro: ['erro'],
    setDetalhesMetasEducacaoLiquidacaoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDetalhesMetasEducacaoLiquidacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesMetasEducacaoLiquidacaoInicio())
        let serv = new DetalhesMetasEducacaoLiquidacaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesMetasEducacaoLiquidacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesMetasEducacaoLiquidacaoErro(error)))
    }
}

const buscaDetalhesMetasEducacaoLiquidacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesMetasEducacaoLiquidacaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhesMetasEducacaoLiquidacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.detalhesMetasEducacaoLiquidacao, carregando: false }
}

const setDetalhesMetasEducacaoLiquidacaoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_METAS_EDUCACAO_LIQUIDACAO_INICIO]: buscaDetalhesMetasEducacaoLiquidacaoInicio,
    [Types.BUSCA_DETALHES_METAS_EDUCACAO_LIQUIDACAO_ERRO]: buscaDetalhesMetasEducacaoLiquidacaoErro,
    [Types.BUSCA_DETALHES_METAS_EDUCACAO_LIQUIDACAO_SUCESSO]: buscaDetalhesMetasEducacaoLiquidacaoSucesso,
    [Types.SET_DETALHES_METAS_EDUCACAO_LIQUIDACAO_ESTADO_DT]: setDetalhesMetasEducacaoLiquidacaoEstadoDT,
})
